import { IReturnResponse } from '@widgets/Files/model/types/api.interface';

export const handleStatusError = (data: IReturnResponse, btnText: string) => {
    if (data?.status === 'error') {
        // @ts-ignore
        swal({
            text: data.message,
            cancel: false,
            confirm: true,
            button: {
                text: btnText,
                value: true,
                visible: true,
                className: 'btn btn-secondary',
            },
        });
    }
};
